<template>
  <div class="content regimes_bens p-1">
    <h4 class="regime_title">
      <b>Complemento do Regime de Bens</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row class="justify-content-between align-items-center">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label
              for="busca"
              class="regime_bens_label">Buscar complemento do regime de bens</label>
            <input
              id="busca"
              v-model="search"
              class="col-md-12 form-control form-control-sm"
              name="busca"
              placeholder="Digite o nome do complemento"
              type="text">
          </div>
        </div>
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label
              for="busca"
              class="regime_bens_label">Regime de Bens</label>
            <v-select id="regime_bens"
                      v-model="search_regime"
                      class="form-control form-control-sm"
                      placeholder="Selecione"
                      :reduce="type => type.value"
                      :options="types" />
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button
              variant="secondary"
              size="sm"
              @click="showModal()">
              <svg
                class="button_edit_label_icon icon--xxs"
                role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar Complemento
            </b-button>
          </div>
        </div>
      </b-row>

      <Table
        :fields="fields"
        :data="regimesFiltered"
        :is-busy="isBusy"
        :search="search"
        field-search="complemento"
        @showModal="showModal"
        @deleteItem="deleteRegime"
        @onUpdateAtivo="updateAtivo" />
    </div>

    <Pagination
      :per-page="perPage"
      :page="page"
      :last-page="lastPage"
      @onPreviousPage="previousPage"
      @onNextPage="nextPage" />

    <form
      autocomplete="off"
      class="no-padding"
      @submit.prevent="callMethod()">
      <b-modal
        id="modal-cadastro"
        size="lg"
        class="no-padding"
        hide-header
        no-close-on-backdrop
        no-close-on-esc>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-row align-h="end">
              <b-button
                size="sm"
                class="btn btn-sm btn_voltar"
                variant="outline"
                @click="$bvModal.hide('modal-cadastro')">
                Voltar
              </b-button>
              <b-button
                size="sm"
                type="submit"
                class="mr-3"
                :disabled="!form.descricao || !form.complemento">
                {{ form.editar ? "Atualizar" : "Adicionar" }}
              </b-button>
            </b-row>
          </div>
        </template>

        <div class="row">
          <div role="group"
               class="col-5 form-group">
            <label
              for="input-live"
              class="label">Regime de Bens</label>
            <v-select :id="`regime-bens-${_uid}`"
                      v-model="form.descricao"
                      class="form-control form-control-sm"
                      placeholder="Selecione"
                      :reduce="type => type.value"
                      :options="types" />
          </div>
          <div role="group"
               class="col-6 form-group">
            <label
              for="input-live"
              class="label">Nome do complemento</label>
            <input
              v-model="form.nome"
              v-validate="'required'"
              class="form-control form-control-sm"
              placeholder="Nome do complemento"
              name="nome_complemento"
              :class="{'is-invalid': errors.has('nome_complemento')}">
            <small class="invalid-feedback">{{ errors.first('nome_complemento') }}</small>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group">
            <label class="label">Descrição do complemento</label>
            <textarea
              v-model="form.complemento"
              class="form-control form-control-sm w-100"
              placeholder="Descrição do complemento"
              cols="30"
              rows="4" />
          </div>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
	/* components */
  import Pagination from "@/components/SofiaRei/Pagination"
  import Table from "@/components/SofiaRei/Table"

  /* services */
  import RegimeBensService from "@/services/Registros/RegimeBensService"

  /* assets */
  import excludeIcon from "@/assets/icons/ic_delete_24px.svg?sprite"
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"
  import add from '@/assets/icons/add.svg?sprite'

  /* outros */
  import debounce from 'lodash/debounce'
  import { mapGetters } from 'vuex'

  export default {
    name: "RegimeDeBens",
    components: {
      Pagination,
      Table,
    },
    data () {
      return {
        search: null,
        search_regime: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        excludeIcon,
        editIcon,
        eyeIcon,
        add,
        read: false,
        fields: [{
          key: 'id',
          label: 'Ativo'
        },{
          key: 'descricao',
          label: 'Regime de bens'
        },{
          key: 'nome',
          label: 'Nome do complemento'
        },{
          key: 'complemento',
          label: 'Descrição do complemento'
        },{
          key: 'acoes2',
          label: ''
        }],
        regimes: [],
        types: [
          {
            value: 'COMUNHAO_PARCIAL',
            label: 'Comunhão parcial de bens'
          },
          {
            value: 'COMUNHAO_UNIVERSAL',
            label: 'Comunhão universal de bens'
          },
          {
            value: 'PARTICIPACAO_FINAL_AQUESTOS',
            label: 'Participação final aquestos'
          },
          {
            value: 'SEPARACAO_BENS',
            label: 'Separação de Bens'
          },
          {
            value: 'SEPARACAO_LEGAL_BENS',
            label: 'Separação legal de bens'
          },
          {
            value: 'OUTROS',
            label: 'Outros'
          },
          {
            value: 'IGNORADO',
            label: 'Ignorado'
          }
        ],
        form: {
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: null,
          descricao: null,
          complemento: null,
          editar: null
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: "auth/getCartorioId",
      }),
      regimesFiltered () {
        return this.regimes.map(regime => {
          const tipo = this.types.find(type => type.value === regime.descricao)

          if (tipo) {
            regime.descricao = tipo.label
          }

          return regime
        })
      }
    },
    watch: {
      search: function () {
        this.isBusy = true
        this.viewWatch()
      },
      search_regime () {
        this.isBusy = true
        this.viewWatch()
      },
    },
    beforeMount () {
      try {
        loader({ text: "Obtendo dados...", active: true })
        this.init()
      } catch (e) {
        loader({ text: "", active: false })
      }
    },
    created () {
      this.viewWatch = debounce(function () {
        this.searchRegimeBens()
      }, 200)
    },
    methods: {
      async init () {
        const regimes = await RegimeBensService.getRegimeBens({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: this.perPage,
          page: this.page
        })
        this.regimes = regimes.data
        this.lastPage = regimes.lastPage
        this.isBusy = false
        loader({ text: "", active: false })
      },
      async showModal (regime = { data: {}, read: false }) {
        const { data, read } = regime

        if (read) {
          return
        }

        this.$bvModal.show('modal-cadastro')

        if (data.regime_de_bens_id) {

          const regime = this.types.find(type => data.descricao === type.label)

          this.form.regime_de_bens_id = data.regime_de_bens_id
          this.form.nome = data.nome
          this.form.descricao = regime ? regime.value : data.descricao
          this.form.complemento = data.complemento
          this.form.editar = true
        } else {
          this.form = {
            nome: null,
            descricao: null,
            complemento: null,
          }

          this.$validator.reset()
        }
      },
      async callMethod () {
        if (this.form.regime_de_bens_id) {
          this.updateRegimeBens(this.form)
        } else {
          this.saveRegimeBens(this.form)
        }
      },
      async saveRegimeBens (regime) {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        try {
          loader({ text: "Aguarde...", active: true })

          regime.cartorio_id = this.$store.state.auth.cartorio_id
          const { data } = await RegimeBensService.storeRegimeBens(regime)
          if (data.regime_de_bens_id) {
            this.init()
            objSwal.success.title = "Salvo com sucesso!"
            objSwal.success.text = ''
            Swal.fire(objSwal.success)

            this.$bvModal.hide('modal-cadastro')
          } else {
            objSwal.warning.title = "Erro ao salvar, tente novamente!"
            Swal.fire(objSwal.warning)
          }
        }
        catch (e) {
          const message = getErrors(e)
          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: "", active: false })
        }
      },
      async updateRegimeBens (regime, alert = true, validar = true) {
        const valid = await this.$validator.validateAll()

        if (!valid && validar) return

        try {
          loader({ text: "Aguarde...", active: true })

          const { regime_de_bens_id } = regime
          regime.cartorio_id = this.$store.state.auth.cartorio_id,
          delete regime["regime_de_bens_id"]
          let data = await RegimeBensService.updateRegimeBens(regime, regime_de_bens_id)
          if (data.regime_de_bens_id) {
            if (alert) {
              objSwal.success.title = "Atualizado com sucesso!"
              objSwal.success.text = ''
              this.init()
              Swal.fire(objSwal.success)
            }

            this.$bvModal.hide('modal-cadastro')
          } else {
            objSwal.warning.title = "Erro ao atualizar, tente novamente!"
            Swal.fire(objSwal.warning)
          }
        }
        catch (e) {
          const message = getErrors(e)
          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: "", active: false })
        }
      },
      onError (title = 'Erro', text = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        return Swal.fire(objSwal.error)
      },

      deleteRegime (val) {
        objSwal.question.title = ''
        objSwal.question.text = 'Confirma a exclusão deste Regime de Bens?'

        return Swal.fire (objSwal.question).then(result => {
          if (result.value) {
            RegimeBensService.excludeRegimeBens(val.regime_de_bens_id).then(res => {
              this.init()
              objSwal.success.title = 'Regime de bens excluído'
              objSwal.success.text = ''
            }).catch(({ message }) => this.onError(`Erro ao deletar Regime de Bens.`, message))
          }
        })
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      async searchRegimeBens () {
        let regimes = await RegimeBensService.getRegimeBens({
          cartorio_id: this.$store.state.auth.cartorio_id,
          descricao: this.search_regime,
          nome: this.search
        })
        this.regimes = regimes.data
        this.lastPage = regimes.lastPage
        this.isBusy = false
      },
      updateAtivo (data) {
        const regime = this.types.find(type => data.descricao === type.label)

        const obj = {
          ...data,
          descricao: regime ? regime.value : data.descricao,
          cartorio_id: this.$store.state.auth.cartorio_id,
          ativo: !data.ativo,
        }
        this.updateRegimeBens(obj, true, false)
      },
      changeRead () {
        this.read = !this.read
      },
    }
  }
</script>

<style lang="scss" >
  @import "../../scss/_utilities/_exports";

  .button_edit_label_icon {
    fill: #fff;
  }

  .button_delete_label_icon {
    fill: #fff;
  }

  .regime{
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }

		&_bens_label {
			font-size: pxToRem(14);
		}
  }

	.btn {
		&_voltar {
			background-color: #c6c6c6;
			margin-right: 14px;
		}
	}
</style>
